import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';

import {
  backwardableOnIntersection,
  forwardableOnIntersection
} from '~/selectors/CanvasSelectors';
import {backward, forward} from '~/actions/IconActions';

export const select = () =>
  createStructuredSelector({
    actives: createStructuredSelector({
      canSendToBack: backwardableOnIntersection,
      canSendToFront: forwardableOnIntersection
    })
  });

export const actions = dispatch => {
  return {
    actions: bindActionCreators(
      {
        sendToBack: backward,
        sendToFront: forward
      },
      dispatch
    )
  };
};
